import { Box, Typography, IconButton, Modal } from '@mui/material'
import { useState } from 'react'
import CloseIcon from '@mui/icons-material/Close'
import { useTranslation } from 'react-i18next'
import GridItem from '../../../../kyc/kycPerson/components/GridItem'
import { CollapsibleSection } from '../CollapsibleSection'
import styles from './styles.module.scss'

export const LivenessDetails = ({ vendorData }) => {
  const { t } = useTranslation(['common'])
  const [selectedImage, setSelectedImage] = useState(null)

  if (!vendorData || !vendorData.liveness) {
    return null
  }

  const liveness = vendorData.liveness

  const summary = `${t('common:score')}: ${liveness.score} - ${t('common:status')}: ${liveness.status}`

  return (
    <>
      <CollapsibleSection title={t('common:livenessDetails')} summary={summary}>

        <Box className={styles.gridItems}>
          <GridItem name={t('common:score')} value={liveness.score} />
          <GridItem name={t('common:status')} value={liveness.status} />
          <GridItem name={t('common:method')} value={liveness.method || 'N/A'} />
          {liveness.age_estimation && <GridItem name={t('common:ageEstimation')} value={liveness.age_estimation} />}
        </Box>

        {liveness.reference_image && (
          <Box className={styles.imageContainer}>
            <Box className={styles.imageBox} onClick={() => setSelectedImage(liveness.reference_image)}>
              <Box className={styles.imageHeader}>
                <Typography variant="subtitle2" fontWeight={600}>
                  {t('common:referenceImage')}
                </Typography>
              </Box>
              <Box className={styles.imageWrapper}>
                <img src={liveness.reference_image} alt="Liveness Reference" className={styles.verificationImage} />
              </Box>
            </Box>
          </Box>
        )}

        {liveness.warnings && liveness.warnings.length > 0 && (
          <Box className={styles.warningsSection}>
            <Typography variant="subtitle2" mb={1} color="warning.main">
              Warnings:
            </Typography>
            {liveness.warnings.map((warning, index) => (
              <Box key={index} className={styles.warningItem}>
                <Typography variant="body2" fontWeight={600}>
                  {warning.short_description}
                </Typography>
                <Typography variant="caption" color="textSecondary">
                  {warning.long_description}
                </Typography>
              </Box>
            ))}
          </Box>
        )}
      </CollapsibleSection>

      {/* Lightbox Modal */}
      <Modal
        open={!!selectedImage}
        onClose={() => setSelectedImage(null)}
        sx={{ zIndex: 99999 }}
      >
        <Box className={styles.modal} onClick={() => setSelectedImage(null)}>
          <Box className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <IconButton className={styles.closeButton} onClick={() => setSelectedImage(null)}>
              <CloseIcon />
            </IconButton>
            <img src={selectedImage} alt="Liveness" className={styles.modalImage} />
          </Box>
        </Box>
      </Modal>
    </>
  )
}
